/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterOrigin_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterOrigin_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterOrigin_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterOrigin_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '14194ad7a0d4d805cf2e7d5c2687e616';
module.exports = node;
